import { _trimFuturePeriods, getPercentage, getPreviousMonthsData, getPreviousYearData, getValueFromDotSeparatedKey } from '../utils';

function formatTime(data, isWeekly, simple) {
	let month = data && data.val;
	
	if (month) {
	  const date = new Date(month);
	  const monthName = simple ? date.toLocaleString('default', { month: 'short', timeZone: 'UTC' }) : date.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
	  const year = date.getUTCFullYear();
	  if (isWeekly === "+7DAY") {
		const day = date.getDate();
		if(simple){
		  return `${monthName} ${day}, ${year}`
		}else{
		  return `Week of ${monthName} ${day}, ${year}`;
		}
		
		
	  } else if (isWeekly === "+1MONTH") {
		return `${monthName} ${year}`;
	  } else if (isWeekly === "+3MONTH") {
		const month = date.getUTCMonth(); // Get the month (0-11)
		const year = date.getUTCFullYear(); // Get the full year
		
		// Determine the quarter based on the month
		let quarter;
		if (month >= 0 && month <= 2) {
			quarter = 'Q1';
		} else if (month >= 3 && month <= 5) {
			quarter = 'Q2';
		} else if (month >= 6 && month <= 8) {
			quarter = 'Q3';
		} else {
			quarter = 'Q4';
		}
		
		return `${quarter} ${year}`;
	  }else{
		return `${year}`;
	  }
	} else {
	  return ""; 
	}
  }



export default function MarketCardToJson({ cardListViewData, isWeekly, checkedType, title, subTitle, fetchInProgress, type, statKey, formatter, returnData }) {
  cardListViewData = _trimFuturePeriods(cardListViewData);
  
  const monthlyData = getPreviousMonthsData(cardListViewData);
  const yearlyData = getPreviousYearData(cardListViewData, monthlyData && monthlyData[1] && monthlyData[1].val, isWeekly);

  const keyStat = monthlyData && monthlyData[1] && monthlyData[1][type.key] && getValueFromDotSeparatedKey(monthlyData[1][type.key], statKey) ? formatter(getValueFromDotSeparatedKey(monthlyData[1][type.key], statKey)) : "--";
  const newVal = monthlyData && monthlyData[1] && monthlyData[1][type.key] ? getValueFromDotSeparatedKey(monthlyData[1][type.key], statKey) : false;
  const oldVal = monthlyData && monthlyData[0] && monthlyData[0][type.key] ? getValueFromDotSeparatedKey(monthlyData[0][type.key], statKey) : false;
  const yearVal = yearlyData && yearlyData[type.key] ? getValueFromDotSeparatedKey(yearlyData[type.key], statKey) : false;

  
  return {
	"Stat_Name" : title,
	"Stat_Period" : formatTime((monthlyData && monthlyData[1] ? monthlyData[1] : false), isWeekly),
	"Stat" : keyStat,
	"Stat_Percent_Change": getPercentage(newVal, oldVal),
	"Stat_Percent_Change_Type": isWeekly === "+7DAY" ? "vs. prior week" : isWeekly === "+1MONTH" ? "vs. prior month" : isWeekly === "+3MONTH" ? "vs. prior quarter" : "vs. prior year"
  };
}
